import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = false;

const isPreguntasModalDisplayedStateSlice = createSlice({
	name: 'isPreguntasModalDisplayedState',
	initialState,
	reducers: {
		setisPreguntasModalDisplayedState: (state, action: PayloadAction<boolean>) => {
			return action.payload;
		},
		resetisPreguntasModalDisplayedState: () => {
			return initialState;
		}
	}
});

export const { setisPreguntasModalDisplayedState, resetisPreguntasModalDisplayedState } =
	isPreguntasModalDisplayedStateSlice.actions;

export default isPreguntasModalDisplayedStateSlice.reducer;
